//定制专题
export const customizedTopicsRouter = [
  {
    path: '/service/customizedTopics/customizedList',
    name: 'CustomizedList',
    component: () => import('@/views/service/serviceProvider/customizedTopics/CustomizedList'),
    meta: {
      title: '定制专题',
      keepAlive: false
    }
  },
  {
    path: '/service/customizedTopics/customizedThemeTemplate',
    name: 'CustomizedThemeTemplate',
    component: () => import('@/views/service/serviceProvider/customizedTopics/CustomizedThemeTemplate'),
    meta: {
      title: '专题模板',
      keepAlive: false
    }
  },
  {
    path: '/service/customizedTopics/customizedAddThemeTemplate',
    name: 'CustomizedAddThemeTemplate',
    component: () => import('@/views/service/serviceProvider/customizedTopics/CustomizedAddThemeTemplate'),
    meta: {
      title: '制作专题',
      keepAlive: false
    }
  }

]